export default __webpack_public_path__ + "static/media/453.b28f71db.jpg";